<template>
  <div>
    <div id="_div" class="col-12">
      <div id="Titulo_div">
        <h1>Agendar cita en juzgado</h1>
        <h3 v-show="mostrarDatosDeUsuarioSolicitante || mostrarJuzgadoTramiteExpediente || mostrarFechaHoraDeCita" class="h3-text">Ingrese la información requerida</h3>
      </div>
      <DatosDeUsuarioSolicitante v-show="mostrarDatosDeUsuarioSolicitante" v-on:valorParaElPadreInformacionSolicitante="obtenerDatosSolicitante"></DatosDeUsuarioSolicitante>
      <JuzgadoTramitesExpedientes v-if="renderizaJuzgadoTramiteExpediente" 
                                  v-show="mostrarJuzgadoTramiteExpediente" 
                                  :parametros="parametros_FechaHoraDeCita"
                                  v-on:valorParaElPadreJuzgadoTramitesExpedientes="obtenerTramitesExpedientes">
      </JuzgadoTramitesExpedientes>
      <FechaHoraDeCita v-if="renderizaFechaHoraDeCita"
                       v-show="mostrarFechaHoraDeCita"
                       :parametros="parametros_FechaHoraDeCita"
                       v-on:valorParaElPadreFechaHoraDeCita="obtenerFechaHoraDeCita"
                       :key="keyCalendario">
      </FechaHoraDeCita>
    </div>
  </div>
</template>

<script>
  import enumeraciones from '@/../static/js/enumeraciones'
  import catalogos from '@/../static/js/catalogos'
  import api from '@/../static/js/api'
  import comun from '@/../static/js/comun'
  import DatosDeUsuarioSolicitante from '@/components/SICCIJ/Citas/AgendarCitas/DatosDeUsuarioSolicitante.vue'
  import JuzgadoTramitesExpedientes from '@/components/SICCIJ/Citas/AgendarCitas/JuzgadoTramitesExpedientes.vue'
  import FechaHoraDeCita from '@/components/SICCIJ/Citas/AgendarCitas/FechaHoraDeCita.vue'
  import axios from 'axios'
  import store from '@/store/index'
  import funcion from '../../../../../static/js/api/comun/funcion/funcion'
  import LogoPJE from '@/../src/assets/logo-pj-transparente-negro.png'

  export default {
    components: {
      DatosDeUsuarioSolicitante,
      JuzgadoTramitesExpedientes,
      FechaHoraDeCita
    },
    data() {
      return {
        enumeraciones,
        peticionGuardado: Object,
        mostrarDatosDeUsuarioSolicitante: true,
        renderizaJuzgadoTramiteExpediente: false,
        mostrarJuzgadoTramiteExpediente: false,
        mostrarFechaHoraDeCita: false,
        renderizaFechaHoraDeCita: false,
        parametros_FechaHoraDeCita: { peticion: {} },
        ConfiguracionCitasDeArea: {},
        mostrarTemporizador: false,
        temporizadorFechaElegida: null,
        areaNombre: "",
        keyCalendario: 0,
        actualizarCada: 90000,
        citaId: 102,
        mensajeCitaAgendada: "",
        mensajeDeAtencion:"",
        contestarEncuesta:{
          target:'_blank',
          path:'https://forms.gle/tZTqunayATnMhJW7A'
        }
      }
    },
    methods: {
      /**
       * Función encargada de obtener la información de datos del solicitante del componente de trámites y llenar la petición para obtener los bloques eventos del calendario
       * @param {} datos [valores del componente de datos de solicitante]
       */
      obtenerDatosSolicitante: function (datos) {
        //#region [parametros para petición de Guardado de Cita]
        this.peticionGuardado = datos;
        //#endregion
        
        this.mostrarDatosDeUsuarioSolicitante = false;

        if(datos!= undefined && datos!= null  && !datos.esError)
        {
          this.mostrarJuzgadoTramiteExpediente = true;
          this.renderizaJuzgadoTramiteExpediente = true;
          //#region [parametros para Calendario] - Componente -> Elección de fecha y hora de cita
          if (datos.InformacionDeSolicitante.InformacionDeSolicitanteId != null && datos.InformacionDeSolicitante.InformacionDeSolicitanteId != undefined && datos.InformacionDeSolicitante.InformacionDeSolicitanteId > 0) {
            this.parametros_FechaHoraDeCita.peticion.InformacionDeSolicitanteId = datos.InformacionDeSolicitante.InformacionDeSolicitanteId;
          }
          else if (!datos.EsInformacionUsuario)
            this.parametros_FechaHoraDeCita.peticion.CURP = datos.InformacionDeSolicitante.CURP
          this.parametros_FechaHoraDeCita.peticion.EsInformacionDeUsuario = datos.EsInformacionUsuario;
          //#endregion
        }        
      },
      /**
       * Función encargada de obtener la información del componente de trámites y llenar la petición para obtener los bloques eventos del calendario
       * @param {} datos [valores del componente de trámites]
       */
      obtenerTramitesExpedientes: function (datos) {
        if (datos.Siguiente == true) {
          //#region [parametros para Calendario] - Componente -> Elección de fecha y hora de cita
          this.parametros_FechaHoraDeCita.peticion.AreaId = datos.AreaId;
          this.ConfiguracionCitasDeArea = datos.ConfiguracionCitasDeArea;
          this.parametros_FechaHoraDeCita.horarioAtencionInicio = this.ConfiguracionCitasDeArea.HorarioAtencionInicio.toString();
          this.parametros_FechaHoraDeCita.horarioAtencionFinal = this.ConfiguracionCitasDeArea.HorarioAtencionFinal.toString();
          this.parametros_FechaHoraDeCita.tiempoEntreBloques = this.ConfiguracionCitasDeArea.TiempoPorBloque.toString();
          this.areaNombre = datos.NombreArea;
          let tramitesIds = datos.ListadoTramites.map((tipoTramite) => tipoTramite.TipoTramiteId);
          this.parametros_FechaHoraDeCita.peticion.TiposTramitesIds = tramitesIds;
          //#endregion

          //#region [parametros para petición de Guardado de Cita]
          this.peticionGuardado.TramitesCitas = datos.ListadoTramites;
          this.peticionGuardado.AreaId = datos.AreaId;
          this.peticionGuardado.NotasDelSolicitante = datos.NotasDelSolicitante;
          //#endregion

          this.mostrarJuzgadoTramiteExpediente = false;
          this.mostrarFechaHoraDeCita = true;
          this.renderizaFechaHoraDeCita = true;
          this.$store.state.SICCIJ_AgendarCita_TemporizadorFechaHoraSeleccionadaCuenta = moment(this.actualizarCada);
          clearInterval(this.$store.state.SICCIJ_AgendarCita_TemporizadorFechaHoraSeleccionada);
          this.$store.state.SICCIJ_AgendarCita_TemporizadorFechaHoraSeleccionada = null;
          this.iniciarTemporizador();
        }
        else {
          this.mostrarDatosDeUsuarioSolicitante = true;
          this.mostrarJuzgadoTramiteExpediente = false;
        }
      },
      /**
       * Función encargada de obtener la fecha y hora de cita del componente y llamar a API para agendar cita
       * @param {} datos [valor de fecha y hora del componente FechaHoraDeCita]
       */
      obtenerFechaHoraDeCita: function (datos) {
        clearInterval(this.$store.state.SICCIJ_AgendarCita_TemporizadorFechaHoraSeleccionada);
        if (datos.Siguiente) {
          //#region [parametros para petición de Guardado de Cita]
          comun.SeEstaCargandoInformacion(true);
          this.peticionGuardado.AgendaBloqueId = datos.AgendaBloqueId;

          this.peticionGuardado.EsPrueba = this.enumeraciones.EsPrueba;
          const headerPeticion = comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal, false);

          axios.post(api.conexion + api.SICCIJ.sistema.citas.AgendarCita.AgendarCita, this.peticionGuardado, headerPeticion)
            .then(respuesta => {
              comun.SeEstaCargandoInformacion(false);
              if (respuesta.data.SiHayError) {
                console.log(respuesta);
                /*comun.mensajeDeAlerta(respuesta.data.Error.Mensaje,null, null);
                this.$store.state.SICCIJ_AgendarCita_TemporizadorFechaHoraSeleccionadaCuenta = moment(1000);
                this.$store.state.SICCIJ_AgendarCita_TemporizadorFechaHoraSeleccionada = null;*/
                //this.iniciarTemporizador();
                bootbox.dialog({
                  title: "Mensaje del sistema",
                  message: respuesta.data.Error.Mensaje,
                  buttons: {
                    aceptar: {
                      label: 'Aceptar',
                      callback: () => {
                        this.$store.state.SICCIJ_AgendarCita_TemporizadorFechaHoraSeleccionadaCuenta = moment(1000);
                        this.$store.state.SICCIJ_AgendarCita_TemporizadorFechaHoraSeleccionada = null;
                        this.iniciarTemporizador();
                      }
                    }
                  }
                });
              } else {
                moment.locale('es');
                this.mensajeCitaAgendada = respuesta.data.Satisfactorio + "<br /><br />Folio: " + respuesta.data.Folio + "<br />Fecha y hora de cita: " + moment(respuesta.data.FechaDeCita).format("LLLL") + "<br />Lugar: " + this.areaNombre + "<br />";
                this.mensajeDeAtencion = "<br /><b style='color:yellow;'>A T E N C I Ó N:</b> <i>Por parte del Juzgado se le enviará a su correo electrónico la confirmación de su cita, para hacerle saber la disponibilidad de los expedientes o trámites solicitados; si no lo visualiza en la bandeja de entrada, revise su bandeja de 'spam' o 'correo no deseado' un día antes de su cita.</i>";
                this.mostrarFechaHoraDeCita = false;
                bootbox.dialog({
                  title: 'Mensaje del sistema',
                  message: this.mensajeCitaAgendada + this.mensajeDeAtencion,
                  size: 'medium',
                  buttons: {
                    aceptar: {
                      label: "Aceptar",
                      className: 'btn btn-primary',
                      callback: () => {
                        comun.SeEstaCargandoInformacion(true);
                        this.despliegaCuestionario();
                        this.$router.go();
                      }
                    }
                  }
                });
                this.citaId = respuesta.data.Folio;
                this.generarPDF();
              }

            })
            .catch(excepcion => {
              comun.SeEstaCargandoInformacion(false);
              console.log(excepcion);
              comun.mensajeDeAlerta(comun.mensajeDeError(this.enumeraciones.error.E500), null, null)
              this.$store.state.SICCIJ_AgendarCita_TemporizadorFechaHoraSeleccionadaCuenta = moment(1000);
              this.$store.state.SICCIJ_AgendarCita_TemporizadorFechaHoraSeleccionada = null;
              this.iniciarTemporizador();
            })

          //#endregion
        }
        else {
          this.mostrarJuzgadoTramiteExpediente = true;
          this.mostrarFechaHoraDeCita = false;
          this.renderizaFechaHoraDeCita = false;
        }
      },
      /**
       * Función encargada generar el PDF comprobante de cita
       */
      generarPDF: function () {
        var peticion = {
          "esPrueba": false,
          "CitaId": this.citaId
        };
        var errorAlGenerarComprobante = false;
        comun.SeEstaCargandoInformacion(true);
        axios.post(api.conexion + api.SICCIJ.funciones.GetCita, peticion, comun.CrearElHeaderDeAutorizacion(store.state.Login_AutorizacionOriginal)).then(response => {
          if (response.data.SiHayError == false) {//En caso de que la petición sea exitosa
            //console.log(response.data)
            var Cita = response.data.Cita
            var expedientes = "";
            /*expedientes += "<ul>";
            Cita.TramitesCita.forEach(function (Tramite) {
              expedientes += "<li>" + Tramite.TipoTramite.Nombre + "</li>"
              expedientes += "<ul>";
              Tramite.Expedientes.forEach(function (Expediente) {
                //console.log(Expediente.ExpedienteId);
                expedientes += "<li>"+Expediente.TipoDocumento_DBPJ.Nombre+" - " + Expediente.NumeroDeExpediente + "</li>";
              });
              expedientes += "</ul>";
            });
            expedientes += "</ul>";*/
            var contenidoPDF = "<table>" +
              "<tr><td><h4>Número de Folio: </h4></td><td style='padding-left:1em;'>" + this.citaId + "</td><td rowspan='5'>" + expedientes + "</td></tr>" +
              "<tr><td><h4>Nombre del Solicitante: </h4></td><td style='text-transform: uppercase; padding-left:1em;'>" + Cita.InformacionDeSolicitante.Nombres + " " + (Cita.InformacionDeSolicitante.PrimerApellido != null? Cita.InformacionDeSolicitante.PrimerApellido + " " : "") + (Cita.InformacionDeSolicitante.SegundoApellido != null ? Cita.InformacionDeSolicitante.SegundoApellido : "") + "</td></tr>" +
              "<tr><td><h4>CURP: </h4></td><td style='text-transform: uppercase; padding-left:1em;'>" + Cita.InformacionDeSolicitante.CURP + "</td></tr>" +
              "<tr><td><h4>Fecha y hora de cita: </h4></td><td style='padding-left:1em;'> " + Cita.AgendaBloque.FechaHoraString + "</td></tr>" +
              "<tr><td><h4>Lugar: </h4></td><td style='padding-left:1em;'>" + Cita.Area.Area_PJ.Nombre + "</td></tr>" +
              "</table>"+
              "<div style='margin-top:1.5em;'><h2 style='display: inline;'>A T E N C I Ó N: </h2><span style='font-style: italic; font-size: 1.5em; display: inline;'>Por parte del Juzgado se le enviará a su <b>correo electrónico</b> la confirmación de su cita, para hacerle saber la disponibilidad de los expedientes o trámites solicitados; si no lo visualiza en la bandeja de entrada, revise su bandeja de 'spam' o 'correo no deseado' un día antes de su cita.</span></div>";
            
            
            var popupWin = window.open('', '_blank', 'location=no,left=100px');
            try {
              comun.SeEstaCargandoInformacion(false);
              popupWin.document.open(); 
              popupWin.document.write('<html><head><title>Comprobante de Cita</title>');
              popupWin.document.write('<link rel="" href="/src/assets/favicon.ico">');
              popupWin.document.write('<link href="/static/css/bootstrap.min.css" rel="stylesheet">');
              popupWin.document.write('<link href="/static/css/all.min.css" rel="stylesheet">');
              popupWin.document.write('<link href="/static/css/bootstrap-table.min.css" rel="stylesheet">');
              popupWin.document.write('</head><body >')
              popupWin.document.write('<img src="' + LogoPJE +'" style="object-fit: cover; width: 10vw; height: 10vw;" alt="Logo de Poder Judicial del Estado de Aguascalientes"/>');
              popupWin.document.write('<h2>Comprobante de Cita </h2>')

              popupWin.document.write(contenidoPDF);
              popupWin.document.write('<hr></body></html>');

              setTimeout(
                function () { 
                  popupWin.print(); 
                }, 1000
              );

              popupWin.document.close();
              popupWin.focus(); 

            } catch (e) {
              console.log(e);
              errorAlGenerarComprobante = true;
              $('.bootbox.modal').modal('hide');
              bootbox.dialog({
                title: 'Mensaje del sistema',
                message: this.mensajeCitaAgendada + "<br />Sucedió un error al generar su comprobante, asegúrese de tener habilitadas las <b style='color:yellow;'>ventanas emergentes</b>.<br />" + this.mensajeDeAtencion,
                size: 'medium',
                buttons: {
                  aceptar: {
                    label: "Aceptar",
                    className: 'btn btn-primary',
                    callback: () => {
                      comun.SeEstaCargandoInformacion(true);
                      this.despliegaCuestionario();
                      this.$router.go();
                    }
                  }
                }
              });
            }
          }
          else {
            comun.SeEstaCargandoInformacion(false);
            console.error(response);
            comun.mensajeDeAlerta(response.data.Error.Mensaje, null, null)
          }
          
        }).catch(e => {
          console.error("encontre un error " + e);
          comun.mensajeDeAlerta(comun.mensajeDeError(enumeraciones.error.E500), null, null);
        });

      },
      /**
       * Función encargada de redireccionar a link de cuestionario
       */
      despliegaCuestionario() {
        //let route = this.$router.resolve({path: ''});
        //window.open(route.href, '_blank');
        window.open(this.contestarEncuesta.path, this.contestarEncuesta.target);
      },
      /**
       * Función encargada de inicializar el temporizador para actualizar el calendario de eventos de bloques de agenda
       */
      iniciarTemporizador: function () {
        if (this.$store.state.SICCIJ_AgendarCita_TemporizadorFechaHoraSeleccionada == null) {
          this.$store.state.SICCIJ_AgendarCita_TemporizadorFechaHoraSeleccionada = setInterval(async () => {
            this.$store.state.SICCIJ_AgendarCita_TemporizadorFechaHoraSeleccionadaCuenta = moment(this.obtenerTemporizadorFechaHoraSeleccionadoCuenta).subtract(1, 'seconds');
            if (this.obtenerTemporizadorFechaHoraSeleccionadoCuenta == 0) {
              $('.bootbox.modal').modal('hide');
              //comun.mensajeDeAlerta("El tiempo para agendar la cita terminó, el calendario se actualizó.", null, null);
              //this.$store.state.SICCIJ_AgendarCita_TemporizadorFechaHoraSeleccionadaCuenta = moment(60000);
              //this.keyCalendario++;
              this.mensajeRecargarCalendario();
            }
          }, 1000);
        }
      },
      /**
       * Función encargada de mostrar mensaje cuando el tiempo para agendar termina
       */
      mensajeRecargarCalendario: function()
      {
        clearInterval(this.$store.state.SICCIJ_AgendarCita_TemporizadorFechaHoraSeleccionada);
        this.$store.state.SICCIJ_AgendarCita_TemporizadorFechaHoraSeleccionada = null; 
        bootbox.dialog({
          title: 'Mensaje del sistema',
          message: "El tiempo para agendar la cita terminó, el calendario se actualizará.",
          size: 'medium',
          buttons: {
            aceptar: {
              label: "Aceptar",
              className: 'btn btn-primary',
              callback: () => {
                this.$store.state.SICCIJ_AgendarCita_TemporizadorFechaHoraSeleccionadaCuenta = moment(this.actualizarCada);
                this.keyCalendario++;
                this.iniciarTemporizador();
              }
            }
          },
          onEscape: () =>{
            this.mostrarJuzgadoTramiteExpediente = true;
            this.mostrarFechaHoraDeCita = false;
            this.renderizaFechaHoraDeCita = false;
          }
        });
      }
    },
    computed: {
      obtenerTemporizadorFechaHoraSeleccionadoCuenta() {
        return this.$store.getters.Get_SICCIJ_AgendarCita_TemporizadorFechaHoraSeleccionadaCuenta;
      }
    },
    beforeMount() {
      clearInterval(this.$store.state.SICCIJ_AgendarCita_TemporizadorFechaHoraSeleccionada);
    }
  }
</script>

<style scoped>
  .padding-div-low {
    padding-top: 40px;
  }
  .h3-text{
        color: #7e7f74;
    }
</style>



// WEBPACK FOOTER //
// src/components/SICCIJ/Citas/AgendarCitas/AgendarCita.vue